import '../stylesheets/main.scss';
import 'bootstrap/js/dist/offcanvas';
import { Tracker } from "./tracking";
require.context('../images', false);
require.context('../images/certifications', false);
require.context('../images/tech', false);
require.context('../images/logos', false);
var tracker = new Tracker();
